import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Main.css";
import "../processbar.css";
import Nav from "../Nav";
import AOS from "aos";
import "aos/dist/aos.css";
import TestimonialSlider from "./Testimonial";
import CourseCard from "./CourseCard";
import YoutubeCard from "./YoutubeCard";
import NewsletterForm from "./Newsletter";

const Main = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      delay: 390,
    });
  }, []);

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    const container = document.getElementById("image-container");
    const container2 = document.getElementById("image-container2");
    const handleMouseMove = (e) => {
      const offsetX1 = (e.clientX / window.innerWidth - 0.5) * 60;
      const offsetY1 = (e.clientY / window.innerHeight - 0.5) * 40;
      const offsetX2 = (e.clientX / window.innerWidth - 0.5) * 40;
      const offsetY2 = (e.clientY / window.innerHeight - 0.5) * 60;
      container.style.transform = `translate(${offsetX1}px, ${offsetY1}px)`;
      container2.style.transform = `translate(${offsetX2}px, ${offsetY2}px)`;
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <>
      <Nav />

      <section className="w-full mt-20 min-h-screen overflow-x-hidden overflow-y-hidden relative">
        <div className="bg-[#EDFEFF] pb-20 w-full min-h-screen flex flex-col justify-center">
          <div className="grid lg:grid-cols-2 relative">
            <div id="image-container" className="absolute top-0 left-0">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png"
                className="ml-4 mt-4"
                alt="Small Image"
              />
            </div>

            <div className="px-8 py-10" data-aos="fade-in">
              <h1 className="lg:text-[58px] ml-8 lg:ml-20 text-[40px] leading-normal lg:mt-20 league-spartan-main font-montserrat">
                Boost Your Confidence in Spoken English
              </h1>
              <p className="py-4 ml-8 lg:ml-20 font-medium">
                Engaging & Accessible Online Courses For All.
              </p>
              {/* <div className="flex ml-8 lg:ml-20 gap-8">
                <div>
           <Link to='/contact'><button className="bg-teal-500 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-teal-600 transition-all">
  Contact Us
</button></Link>     
                  
                </div>
                <div>
                  <Link to='/Newsletter'><button className="bg-indigo-600 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-700 transition-all">
  Free Pronunciation Guide
</button></Link>
                
                  
                </div>
              </div> */}

{/* <div className="flex flex-wrap lg:flex-nowrap justify-center gap-4 ml-4 lg:ml-20">
  <div>
    <Link to='/contact'>
      <button className="bg-teal-500 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-teal-600 transition-all w-full sm:w-auto">
        Contact Us
      </button>
    </Link>     
  </div>
  <div>
    <Link to='/Newsletter'>
      <button className="bg-indigo-600 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-700 transition-all w-full sm:w-auto">
        Free Pronunciation Guide
      </button>
    </Link>
  </div>
</div> */}

<div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 ml-8 lg:ml-20">
  <div>
    <Link to='/contact'>
      <button className="bg-teal-500 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-teal-600 transition-all w-full sm:w-auto">
        Contact Us
      </button>
    </Link>     
  </div>
  <div>
    <Link to='/Newsletter'>
      <button className="bg-indigo-600 text-white text-xl font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-700 transition-all w-full sm:w-auto">
        Free Pronunciation Guide
      </button>
    </Link>
  </div>
</div>






            </div>
            <div id="image-container2" className="absolute top-400 right-0">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png"
                className="h-32 w-32"
                alt=""
              />
            </div>
            <div data-aos="fade-in">
              <img
                src="newimage/banner/object 1.png"
                className="mt-10 ml-10 w-[650px] h-[650px] max-[1024px]:hidden"
                alt=""
              />
            </div>
          </div>
        </div>

        {/* <div className="grid lg:-mt-12 gap-y-4 gap-x-4 lg:gap-6 mx-auto lg:max-w-[1120px] grid-cols-2 lg:grid-cols-4 p-2 md:p-0">
          <div className="bg-blue-900 w-full lg:w-[240px] h-[140px] rounded-lg">
            <img
              className="mx-auto pt-10 pb-4"
              src="newimage/banner/layer1.png"
              alt="Live Classes"
            ></img>
            <h5 className="text-white text-center">Immersive Method</h5>
          </div>
          <div className="bg-blue-900 w-full lg:w-[240px] h-[140px] rounded-lg">
            <img
              className="mx-auto pt-8 pb-4"
              src="newimage/banner/layer2.png"
              alt="Expert Tutors"
            ></img>
            <h5 className="text-white text-center">Pronunciation Based Speaking</h5>
          </div>
          <div className="bg-blue-900 w-full lg:w-[240px] h-[140px] rounded-lg">
            <img
              className="mx-auto pt-9 pb-4"
              src="newimage/banner/layer3.png"
              alt="Live Classes"
            ></img>
            <h5 className="text-white text-center">Develop Your Listening</h5>
          </div>
          <div className="bg-blue-900 w-full lg:w-[240px] h-[140px] rounded-lg">
            <img
              className="mx-auto pt-8 pb-4"
              src="newimage/banner/layer4.png"
              alt="Expert Tutors"
            ></img>
            <h5 className="text-white text-center">Develop Your Idiomatic Level</h5>
          </div>
        </div> */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mx-auto max-w-[1120px] p-2 md:p-0">
  {[
    { img: "newimage/banner/layer1.png", text: "Immersive Method" },
    { img: "newimage/banner/layer2.png", text: "Pronunciation Based Speaking" },
    { img: "newimage/banner/layer3.png", text: "Develop Your Listening" },
    { img: "newimage/banner/layer4.png", text: "Develop Your Idiomatic Level" },
  ].map((item, index) => (
    <div key={index} className="bg-blue-900 flex flex-col items-center justify-center w-full sm:w-[240px] h-[140px] rounded-lg">
      <img className="w-12 h-12 mb-2" src={item.img} alt={item.text} />
      <h5 className="text-white text-center">{item.text}</h5>
    </div>
  ))}
</div> */}

<div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mx-auto max-w-[1120px] p-2 md:p-0">
  {[
    { img: "newimage/banner/layer1.png", text: "Immersive Method" },
    { img: "newimage/banner/layer2.png", text: "Pronunciation Based Speaking" },
    { img: "newimage/banner/layer3.png", text: "Develop Your Listening" },
    { img: "newimage/banner/layer4.png", text: "Develop Your Idiomatic Level" },
  ].map((item, index) => (
    <div key={index} className="bg-blue-900 flex flex-col items-center justify-center w-full h-[140px] rounded-lg">
      <img className="w-12 h-12 mb-2" src={item.img} alt={item.text} />
      <h5 className="text-white text-center">{item.text}</h5>
    </div>
  ))}
</div>



        <div className="bg-gradient-to-b md:grid md:grid-cols-2 py-10 my-20 from-[#E3FCFC] to-[#6EC2FF] rounded-lg mx-auto max-w-[1024px]">
          <div data-aos="fade-in">
            <img
              className="mt-10 mx-auto md:pl-10 h-full"
              src="newimage/banner/study.png"
              alt="Study"
            ></img>
          </div>
          <div className="md:mr-10 mx-10" data-aos="fade-in">
            <h1 className="lg:text-[44px] text-[40px] leading-normal lg:mt-20 league-spartan-main">
              Premium Learning Experience
            </h1>
            <p className="py-4 font-normal">
              Listen first, then speak next - just as nature intended! Even
              babies start speaking the same way, they keep listening first and
              break the silence afterward! And that’s not just English, it’s the
              same in every language.
            </p>
      <Link to='/courses/FreshStart'><button className="bg-white py-2 px-4 justify-center rounded-lg text-blue-800">
              Read More
            </button></Link>      
          </div>
        </div>
        <CourseCard />

        <NewsletterForm />

        {/* <div className="grid md:grid-cols-2 my-20 from-[#E3FCFC] to-[#6EC2FF] rounded-lg mx-auto max-w-[1024px]">
                    <div>
                        <img className="mt-10 pl-10" src="newimage/banner/newslatter.png" alt="Newsletter"></img>
                    </div>
                    <div className="md:mr-10 mx-10">
                        <h1 className="lg:text-[44px] text-[40px] leading-normal font-medium lg:mt-20">Get started with English HERE</h1>
                        <p className="py-4 font-normal">
                            Be the first to get exclusive offers and the latest news.
                        </p>
                        <div>
                            <input
                                type="text"
                                id="first_name"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Enter your email"
                                required
                            />
                            <button className="bg-blue-700 my-2 py-2 px-4 justify-center rounded-lg text-white">Subscribe</button>
                        </div>
                    </div>
                </div> */}
        <YoutubeCard />

        <div className="my-15" style={{ marginBottom: "30px" }}>
          <TestimonialSlider />
        </div>
      </section>
    </>
  );
};

export default Main;
